// Shared breakpoints and slidesToShow for CategoryRail
export const RAIL_BREAKPOINTS = [
  { breakpoint: 1921, regular: 5, poster: 5, topvideo: 5, topnumber: 4, posterWidth: 220 },
  { breakpoint: 1920, regular: 5, poster: 5, topvideo: 4, topnumber: 4, posterWidth: 150 },
  { breakpoint: 1366, regular: 5, poster: 5, topvideo: 3, topnumber: 4, posterWidth: 160 },
  { breakpoint: 1280, regular: 5, poster: 4, topvideo: 3, topnumber: 4, posterWidth: 160 },
  { breakpoint: 1024, regular: 4, poster: 4, topvideo: 2, topnumber: 3, posterWidth: 160 },
  { breakpoint: 768, regular: 2, poster: 2, topvideo: 2, topnumber: 2, posterWidth: 120 },
  { breakpoint: 0, regular: 1, poster: 1, topvideo: 1, topnumber: 1, posterWidth: 100 },
];

// Slider column for a rail style. Numbered 16:9 rails ('top-number') show one card fewer than a
// regular rail so each thumbnail plus its number is about as wide as a regular card.
export function getRailType(style) {
  if (style === 'top-number-poster') {
    return 'poster';
  }
  if (style === 'top-number') {
    return 'topnumber';
  }
  return 'regular';
}

// Helper to get slidesToShow for a given width and rail style, matching Slick's logic
export function getSlidesToShow(width, style = 'regular') {
  for (const bp of RAIL_BREAKPOINTS) {
    if (width < bp.breakpoint) continue;
    return bp[style] ?? bp['regular'];
  }
  return 1;
}

// Helper to get adaptive slidesToShow based on actual content count
export function getAdaptiveSlidesToShow(width, style = 'regular', contentCount = 0) {
  const maxSlides = getSlidesToShow(width, style);

  // If we have fewer items than max slides, adjust to prevent duplication
  if (contentCount > 0 && contentCount < maxSlides) {
    return Math.min(contentCount, maxSlides);
  }

  return maxSlides;
}

export function getPosterSize(width) {
  for (const bp of RAIL_BREAKPOINTS) {
    if (width < bp.breakpoint) continue;
    const posterWidth = bp.posterWidth;
    return {
      width: posterWidth,
      height: Math.round((posterWidth * 3) / 2),
    };
  }
  return { width: 100, height: Math.round((100 * 3) / 2) };
}
